export default __webpack_public_path__ + "static/Logo Aftersales – 1280px-f8f3d97d5920512b5e00338f406d4564.png";